import styled from '@emotion/styled';
import FieldError from './FieldError';
import { controlStyles } from './TextField';

export interface DateFieldProps {
  id: string;
  value: string | null;
  onChange: (value: string | null) => void;
  min?: string;
  error?: string;
  disabled?: boolean;
  'aria-describedby'?: string;
}

const Input = styled.input<{ invalid: boolean }>(({ invalid }) => controlStyles(invalid));

/**
 * Campo de fecha basado en `<input type="date">`.
 *
 * Trabaja directo con el formato `YYYY-MM-DD`, el mismo que usa la API.
 */
const DateField = ({ id, value, onChange, min, error, disabled, ...rest }: DateFieldProps) => {
  const describedBy =
    [rest['aria-describedby'], error ? `${id}-error` : undefined].filter(Boolean).join(' ') || undefined;

  return (
    <>
      <Input
        id={id}
        type="date"
        value={value || ''}
        min={min}
        disabled={disabled}
        invalid={!!error}
        aria-invalid={!!error}
        aria-describedby={describedBy}
        onChange={event => onChange(event.target.value === '' ? null : event.target.value)}
      />
      {error && <FieldError id={`${id}-error`}>{error}</FieldError>}
    </>
  );
};

export default DateField;
